import { render, staticRenderFns } from "./update-project-location.vue?vue&type=template&id=ef07e62e"
import script from "./update-project-location.vue?vue&type=script&lang=js"
export * from "./update-project-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports